import { TypicaStockAfterEachDeliveryRate, TypicaStockOneTimeAfterFirstDeliveryRate, TypicaStockOneTimeUpfrontRate, TypicaStockOneTimeAfterImportedRate, } from '../constants/orderValues';
export var getOneTimeUpfrontRateLabelKey = function (paymentTimingHandlingRates) {
    var keys = Object.keys(paymentTimingHandlingRates);
    if (keys.includes('one_time_upfront_rate')) {
        return 'params.offerList.paymentTimingHandlingRate.oneTimeUpfrontRate';
    }
    else if (keys.includes('one_time_upfront_rate_by_bag_amount')) {
        return 'params.offerList.paymentTimingHandlingRate.oneTimeUpfrontRateByBagAmount';
    }
    else {
        return 'params.offerList.paymentTimingHandlingRate.oneTimeUpfrontRateByWeight';
    }
};
export var getOneTimeUpfrontRateConstraintKey = function (paymentTimingHandlingRates) {
    if (!paymentTimingHandlingRates)
        return;
    var keys = Object.keys(paymentTimingHandlingRates);
    if (keys.includes('one_time_upfront_rate')) {
        return;
    }
    else if (keys.includes('one_time_upfront_rate_by_bag_amount')) {
        return 'pages.roasterOrder.oneTimeUpfrontRateConstraintByBagAmount';
    }
    else {
        return 'pages.roasterOrder.oneTimeUpfrontRateConstraintByWeight';
    }
};
export var getOneTimeUpfrontRateSelectLabelKey = function (paymentTimingHandlingRates) {
    if (!paymentTimingHandlingRates)
        return;
    var keys = Object.keys(paymentTimingHandlingRates);
    if (keys.includes('one_time_upfront_rate')) {
        return;
    }
    else if (keys.includes('one_time_upfront_rate_by_bag_amount')) {
        return 'pages.roasterOrder.oneTimeUpfrontRateByBagAmount';
    }
    else {
        return 'pages.roasterOrder.oneTimeUpfrontRateByWeight';
    }
};
export var getOneTimeUpfrontRateKey = function (paymentTimingHandlingRates) {
    var keys = Object.keys(paymentTimingHandlingRates);
    if (keys.includes('one_time_upfront_rate')) {
        return 'one_time_upfront_rate';
    }
    else if (keys.includes('one_time_upfront_rate_by_bag_amount')) {
        return 'one_time_upfront_rate_by_bag_amount';
    }
    else {
        return 'one_time_upfront_rate_by_weight';
    }
};
export var getOneTimeUpfrontRate = function (paymentTimingHandlingRates, isTypicaStockOrder) {
    if (isTypicaStockOrder)
        return TypicaStockOneTimeUpfrontRate;
    if (!paymentTimingHandlingRates)
        return '';
    var keys = Object.keys(paymentTimingHandlingRates);
    if (keys.includes('one_time_upfront_rate')) {
        var rates = paymentTimingHandlingRates;
        return rates['one_time_upfront_rate'];
    }
    else if (keys.includes('one_time_upfront_rate_by_bag_amount')) {
        var rates = paymentTimingHandlingRates;
        return rates['one_time_upfront_rate_by_bag_amount'];
    }
    else {
        var rates = paymentTimingHandlingRates;
        return rates['one_time_upfront_rate_by_weight'];
    }
};
export var getInstallmentPaymentsRate = function (isTypicaStockOrder, installmentPaymentTimingType, paymentTimingHandlingRates) {
    var typicaStockInstallmentPaymentTimingHandlingRate = typicaStockPaymentTimingHandlingRate(installmentPaymentTimingType);
    if (isTypicaStockOrder)
        return typicaStockInstallmentPaymentTimingHandlingRate;
    if (!paymentTimingHandlingRates)
        return '';
    return paymentTimingHandlingRates[installmentPaymentTimingType];
};
var typicaStockPaymentTimingHandlingRate = function (installmentPaymentTimingType) {
    switch (installmentPaymentTimingType) {
        case 'after_each_delivery_rate':
            return TypicaStockAfterEachDeliveryRate;
        case 'one_time_after_imported_rate':
            return TypicaStockOneTimeAfterImportedRate;
        case 'one_time_after_first_delivery_rate':
            return TypicaStockOneTimeAfterFirstDeliveryRate;
        default:
            return '0';
    }
};
